import data from "../../shared/data";
import logger from "@/utils/logger";

export async function setUser({ commit }, user) {
  commit("setUser", user);
}

export async function getArticles() {
  const result = await data.get("/api/Products");

  //commit("SET_ARTICLE", result);
  return result;
}

export async function exportProducts() {
  const result = await data.getFile("/api/Products/Export/");

  return result;
}

export async function getArticle(x, productId) {
  const result = await data.get("/api/Products/" + productId);

  return result;
}

export async function getGetCustomFields() {
  const result = await data.get("/api/Admin/GetCustomFields");

  return result;
}

export async function getJobs() {
  const result = await data.get("/api/Job/GetAll");
  return result;
}

export async function putArticle(x, payload) {
  const result = await data.put(
    "/api/Products/" + payload.internalID,
    payload.productDto
  );

  return JSON.parse(result);
}

export async function postArticle(x, payload) {
  const result = await data.post("/api/Products", payload);

  return JSON.parse(result);
}

export async function addAndActivateRequiredFields() {
  const result = await data.post(
    "/api/CustomField/AddAndActivateRequiredFields"
  );

  return JSON.parse(result);
}

export async function getStocks(x, payload) {
  var includeEmptyStock = false;

  if (payload != null) {
    includeEmptyStock = payload.includeEmptyStock;
  }

  const result = await data.get(
    "/api/Stock?includeEmptyStock=" + includeEmptyStock
  );
  return result;
}

export async function deleteStock(x, id) {
  const result = await data.delete("/api/Stock/" + id);

  return result;
}

export async function getStocksIncludeEmpty() {
  const result = await data.get("/api/Stock?includeEmptyStock=true");
  return result;
}

export async function getStocksByLocationName(x, name) {
  const result = await data.get("/api/Stock/StocksByLocationName/" + name);
  return result;
}

export async function getStocksByWarehouse(x, id) {
  const result = await data.get("/api/Stock/StocksByWarehouse/" + id);
  return result;
}

export async function getStocksGroupedByWarehouse(x, payload) {
  var url =
    "/api/Stock/StocksGroupedByWarehouse?includeEmptyLocations=" + payload.includeEmptyLocations;


  var queryString ='';  
  if (payload.statuses != undefined && payload.statuses.length > 0) {
    queryString += "&productStatuses=";
    queryString += payload.statuses.join("&productStatuses=");
    
  }

  if(payload.filter != undefined){
    queryString += "&filter=";
    queryString += payload.filter;
  }

  url = url + queryString;

  const result = await data.get(url);
  return result;
}

export async function getStocksTurnoverRate(x, payload) {
  const result = await data.get(
    "/api/Stock/StocksTurnoverRate/?warehouseId=" +
      payload.warehouseId +
      "&lastXDays=" +
      payload.selectedPeriodDays
  );
  return result;
}

export async function getSupplierStocksByPeriod(x, payload) {
  const result = await data.get(
    "/api/Stock/SupplierStocksByPeriod/?supplierId=" +
      payload.supplierId +
      "&fromDate=" +
      payload.fromDate +
      "&toDate=" +
      payload.toDate
  );
  return result;
}

export async function getPriceCalcultaion() {
  const result = await data.get("/api/PriceCalculation");
  return result;
}

export async function getStockTransactions(x, payload) {
  const { pageNumber, pageSize, sortBy, sortDescending, searchQuery } = payload;

  if (!(pageNumber >= 0 && pageSize > 0)) {
    return null;
  }

  var url = "/api/StockTransaction/Paginated";
  url += `?pageNumber=${encodeURIComponent(pageNumber)}&pageSize=${encodeURIComponent(pageSize)}`;

  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }

  if (sortDescending) {
    url += `&sortDescending=${encodeURIComponent(sortDescending)}`;
  }

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }

  const result = await data.get(url);
  return result;
}

export async function getPurchaseValue(x, payload) {
  let url = "/api/Widget/GetPurchaseValue";
  
  if(payload != undefined && payload != null){
    url += "?supplierId="+payload;
  }

  const result = await data.get(url);
  return result;
}


export async function runPriceCalculation(x, payload) {
  await data.post("/api/PriceCalculation/RunPriceCalculation?type="+payload.type);
}

export async function runPriceCalculationForProduct(x, payload) {
  await data.post("/api/PriceCalculation/RunPriceCalculation/" + payload.id+"?type="+payload.type);
}

export async function postStock(x, payload) {
  const result = await data.post("/api/Stock/CreateOrUpdate", payload);
  return JSON.parse(result);
}

export async function moveStock(x, payload) {
  const result = await data.post("/api/Stock/Move", payload);
  return JSON.parse(result);
}

export async function getStockValue(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending, datetime, warehouseId } = payload;

  let url = `/api/Stock/StockValue?pageNumber=${encodeURIComponent(
    pageNumber
  )}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }
  if (datetime !== null && datetime !== undefined) {
    url += `&datetime=${datetime}`;
  }
    if (warehouseId !== null && warehouseId !== undefined) {
    url += `&warehouseId=${warehouseId}`;
  }


  const result = await data.get(url);
  return result;
}

export async function exportStockValue(x, payload) {
  const { searchQuery, sortBy, sortDescending, datetime, warehouseId } = payload;

  let url = `/api/Stock/StockValue/Export`;

  if (searchQuery || sortBy || sortDescending !== undefined) {
    url += `?`;
  }

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }
   if (datetime !== null && datetime !== undefined) {
    url += `&datetime=${datetime}`;
  }
    if (warehouseId !== null && warehouseId !== undefined) {
    url += `&warehouseId=${warehouseId}`;
  }

  const result = await data.getFile(url);
  return result;
}

export async function exportStocks() {
  const result = await data.getFile("/api/Stock/Export");

  return result;
}

export async function getVatType({ commit }) {
  const result = await data.get("/api/VatType");
  commit("setVatTypes", result);
  return result;
}

export async function getAccount({ commit }) {
  const result = await data.get("/api/Account");

  commit("setAccounts", result);
  return result;
}

export async function getProject({ commit }) {
  const result = await data.get("/api/Project");

  commit("setProjects", result);
  return result;
}
export async function getDepartment({ commit }) {
  const result = await data.get("/api/Department");

  commit("setDepartments", result);
  return result;
}

export async function getWarehouse({ commit }) {
  const result = await data.get("/api/Warehouse");

  commit("setWarehouses", result);
  return result;
}

export async function getLocation({ commit }) {
  const result = await data.get("/api/Location");

  commit("setLocations", result);
  return result;
}

export async function getLocationsWithQuantity() {
  const result = await data.get("/api/Location/GetLocationsWithQuantity");
  return result;
}

export async function getOrders() {
  const result = await data.get("/api/CustomerOrder");

  return result;
}



export async function getCountries() {
  const result = await data.get("/api/Country");

  return result;
}

export async function getOrdersByStatuses(x, payload) {
  const { pageNumber, pageSize, filter, orderStatuses, dep, proj, sortBy, sortDescending } = payload;
  var url = `/api/CustomerOrder/References?pageNumber=${pageNumber}&pageSize=${pageSize}`;

  if (orderStatuses != undefined && orderStatuses.length > 0) {
    var queryStringStatuses = "&status=" + orderStatuses.join("&status=");
    url = url + queryStringStatuses;
  }

  if (dep != undefined && dep.length > 0) {
    var queryStringDep = "&departments=" + dep.join("&departments=");
    url += queryStringDep;
  }

  if (proj != undefined ) {
    var queryStringProj = "&projects=" + proj;
    url = url + queryStringProj;
  }

  if (filter != undefined && filter.length > 0) {
    var queryStringfilter = "&searchQuery=" + filter;
    url = url + queryStringfilter;
  }

  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);

  return result;
}

export async function getReturnOrders(x, statuses) {
  var url = "/api/CustomerOrderItemReturnTransaction/GetReturnOrders/";
  if (statuses != undefined && statuses.length > 0) {
    var queryString = "?status=";
    queryString += statuses.join("&status=");
    url = url + queryString;
  }

  const result = await data.get(url);

  return result;
}

export async function getReturnOrder(x, orderId) {
  const result = await data.get(
    "/api/CustomerOrderItemReturnTransaction/GetReturnOrder/?customerOrderId=" +
      orderId
  );

  return result;
}

export async function getReturnOrderFromInvoice(x, invoiceNumber) {
  const result = await data.get(
    "/api/CustomerOrderItemReturnTransaction/GetReturnOrderFromInvoice/?invoiceNumber=" +
      invoiceNumber
  );

  return result;
}

export async function postReturnItems(x, payload) {
  const result = await data.post(
    "/api/CustomerOrderItemReturnTransaction/SaveReturnItems/" + payload.id,
    payload.items
  );
  return JSON.parse(result);
}

export async function getOrdersByPickDay(x, pickday) {
  var day = pickday != undefined ? pickday : 0;
  const result = await data.get(
    "/api/CustomerOrder/GetByPickDay/?daysFromToday=" + day
  );

  return result;
}

export async function getOrderCountings(x, payload) {
  const result = await data.get(
    "/api/CustomerOrder/GetOrderCountings?fromdate=" + payload.fromDate
  );

  return result;
}

export async function getPurchaseOrdersByPickDay(x, pickday) {
  var day = pickday != undefined ? pickday : 0;
  const result = await data.get(
    "/api/PurchaseOrder/GetByPickDay/?daysFromToday=" + day
  );

  return result;
}

export async function addCustomerOrder(x, payload) {
  const result = await data.post(
    "/api/CustomerOrder/AddOrder/" + payload.customerId,
    payload
  );

  return JSON.parse(result);
}

export async function getDeliveryPressision(x, payload) {
  const result = await data.get(
    "/api/CustomerOrder/GetDeliveryPressision?fromDate=" + payload.fromDate
  );

  return result;
}

export async function requestPayment(x, orderId) {
  const result = await data.post(
    "/api/CustomerOrder/RequestPayment/" + orderId
  );

  return result;
}

export async function addCustomerOrderItems(x, payload) {
  const result = await data.post(
    "/api/CustomerOrder/AddItemsToOrder/" + payload.id,
    payload.items
  );

  return JSON.parse(result);
}

export async function getCustomerOrderItemsByProductAndPeriod(x, payload) {
  return await data.get(
    "/api/CustomerOrderItem/GetByProductAndPeriod/?productId=" +
      payload.productId +
      "&fromDate=" +
      payload.fromDate +
      "&toDate=" +
      payload.toDate
  );
}

export async function getSerialNumberByProductOrCustomer(x, payload) {
  return await data.get(
    "/api/CustomerOrderItem/GetSerialNumberByProductOrCustomer/?productId=" +
      payload.productId +
      "&customerId=" +
      payload.customerId
  );
}

export async function postCustomerOrderItemTransaction(x, payload) {
  const result = await data.post("/api/CustomerOrderItemTransaction", payload);

  return JSON.parse(result);
}

export async function deleteCustomerOrderItemTransaction(x, id) {
  const result = await data.delete("/api/CustomerOrderItemTransaction/" + id);

  return result;
}

export async function deletePurchaseOrderItemTransaction(x, id) {
  const result = await data.delete("/api/PurchaseOrderItemTransaction/" + id);

  return result;
}

export async function getCustomerOrderItemTransactions(x, orderId) {
  const result = await data.get(
    "/api/CustomerOrderItemTransaction/GetByCustomerOrderId/" + orderId
  );

  return result;
}

export async function getpickedProductsReadyToPackaging(x, orderId) {
  const result = await data.get(
    "/api/CustomerOrderItemTransaction/GetpickedProductsReadyToPackaging/" +
      orderId
  );

  return result;
}

export async function getCustomerOrderPackage(x, orderId) {
  const result = await data.get(
    "/api/CustomerOrderPackage/GetByCustomerOrderId/" + orderId
  );

  return result;
}

export async function unlockOrder(x, orderId) {
  const result = await data.post("/api/CustomerOrder/Unlock/" + orderId);
  return result;
}

export async function postCustomerOrderPackage(x, payload) {
  const result = await data.post("/api/CustomerOrderPackage", payload);

  return JSON.parse(result);
}

export async function addCustomerQuote(x, payload) {
  const result = await data.post(
    "/api/CustomerQuote/AddQuote/" + payload.id,
    payload
  );

  return JSON.parse(result);
}

export async function getCustomerQuotes(x, payload) {
  var url = "/api/CustomerQuote";
  var orderStatuses = payload.orderStatuses;

  if (orderStatuses != undefined && orderStatuses.length > 0) {
    var queryString = "?orderStatuses=";
    queryString += orderStatuses.join("&orderStatuses=");
    url = url + queryString;
  }

  const result = await data.get(url);
  return result;
}

export async function addCustomerQuoteItems(x, payload) {
  const result = await data.post(
    "/api/CustomerQuote/AddItemsToQuote/" + payload.id,
    payload.items
  );

  return JSON.parse(result);
}

export async function getSalesOrder(x, orderId) {
  const result = await data.get("/api/CustomerOrder/" + orderId + "/Simplified");

  return result;
}

export async function getDimensions({ commit }) {
  const result = await data.get("/api/Dimensions");

  commit("setDimensions", result);
  return result;
}

export async function getDimensionSettings({ commit }) {
  const result = await data.get("/api/DimensionSettings");

  commit("setDimensionSettings", result);
  return result;
}

export async function getCompany({ commit }) {
  const result = await data.get("/api/Company");

  commit("setCompany", result);
  return result;
}

export async function getSettings({ commit }) {
  const result = await data.get("/api/Settings");

  commit("setSettings", result);
  return result;
}

export async function updateSettings({ dispatch }, payload) {
  const result = await data.put("/api/Settings", payload);
  await dispatch("getSettings");  

  return JSON.parse(result);
}

export async function getPackingSlipReport(x, payload) {
  const result = await data.getFile(
    "/api/Report/PackingSlip/" +
      payload.packageId +
      "?sendEmail=" +
      payload.sendEmail
  );

  return result;
}
export async function getConsignorLabels(x, ShpCSID) {
  const result = await data.get(
    "/api/CustomerOrderPackage/PrintLabels/" + ShpCSID
  );
  return result;
}

export async function getAxiaOptions(x, consignorId) {
  const result = await data.get(
    "/api/CustomerOrderPackage/ClientImportConfigAxia/" + consignorId
  );
  return result;
}

export async function getTop10Products() {
  const result = await data.get("/api/Products/GetTop10");

  return result;
}

export async function getConsignorTracking(x, ShpCSID) {
  const result = await data.get(
    "/api/CustomerOrderPackage/GetTrackingURL/" + ShpCSID
  );
  return result;
}

export async function getPickingListReport(x, payload) {
  var uri = "/api/Report/PickingList/" + payload.customerOrderId;

  if (payload.warehouseId) {
    uri = uri + "?warehouseId=" + payload.warehouseId;
  }

  const result = await data.getFile(uri);

  return result;
}

export async function getPurchaseOrderReport(x, orderId) {
  const result = await data.getFile("/api/Report/PurchaseOrder/" + orderId);

  return result;
}

export async function getPurchaseOrders() {
  const result = await data.get("/api/PurchaseOrder");

  return result;
}

export async function getPurchaseOrdersByStatuses(x, payload) {
  const { pageNumber, pageSize, sortBy, sortDescending, searchQuery, statuses } = payload;

  var url = "/api/PurchaseOrder/References";

  if (!(pageNumber >= 0 && pageSize > 0)) {
    return null;
  }

  url += `?pageNumber=${encodeURIComponent(pageNumber)}&pageSize=${encodeURIComponent(pageSize)}`;

  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }

  if (sortDescending) {
    url += `&sortDescending=${encodeURIComponent(sortDescending)}`;
  }

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }

  if (statuses != undefined && statuses.length > 0) {
    var queryString = "&status=";
    queryString += statuses.join("&status=");
    url = url + queryString;
  }

  const result = await data.get(url);

  return result;
}

export async function getPurchaseOrder(x, orderId) {
  const result = await data.get("/api/PurchaseOrder/" + orderId);

  return result;
}

export async function postPurchaseOrderItemTransaction(x, payload) {
  const result = await data.post("/api/PurchaseOrderItemTransaction", payload);

  return JSON.parse(result);
}

export async function postPurchaseOrderItemTransactionsBatch(x, payload) {
  const result = await data.post("/api/PurchaseOrderItemTransaction/batch", payload);
  return JSON.parse(result);
}

export async function postAddJournalentry(x, id) {
  const result = await data.post("/api/CustomerOrderPackage/AddJournalentry/"+id);

  return JSON.parse(result);
}

export async function postAddJournalentryReturn(x, id) {
  const result = await data.post("/api/CustomerOrderItemReturnTransaction/AddJournalentryReturn/"+id);

  return JSON.parse(result);
}

export async function getCurrencies({ commit }) {
  const result = await data.get("/api/Currency/CurrencyCodes");

  commit("setCurrencies", result);
  return result;
}

export async function getExchangeRate(x, id) {
  const result = await data.get("/api/Currency/ExchangeRate/" + id);

  return result;
}

export async function getSuppliers({ commit }) {
  const result = await data.get("/api/Supplier");

  commit("setSuppliers", result);
  return result;
}

export async function postPriceCalculation(x, payload) {
  const result = await data.post("/api/PriceCalculation", payload);

  return JSON.parse(result);
}

export async function postPurchaseOrder(x, payload) {
  const result = await data.post("/api/PurchaseOrder", payload);

  return JSON.parse(result);
}

export async function putPriceCalculation(x, payload) {
  const result = await data.put("/api/PriceCalculation/" + payload.id, payload);

  return JSON.parse(result);
}

export async function putPurchaseOrder(x, payload) {
  const result = await data.put(
    "/api/PurchaseOrder/" + payload.id,
    payload.purchaseDto
  );

  return JSON.parse(result);
}

export async function deletePriceCalculation(x, id) {
  const result = await data.delete("/api/PriceCalculation/" + id);

  return result;
}

export async function deleteSupplierProduct(x, id) {
  const result = await data.delete("/api/SupplierProduct/" + id);

  return result;
}

export async function getSupplierProduct() {
  const result = await data.get("/api/SupplierProduct");
  return result;
}

export async function postSupplierProduct(x, payload) {
  const result = await data.post("/api/SupplierProduct", payload);

  return JSON.parse(result);
}
export async function putSupplierProduct(x, payload) {
  const result = await data.put(
    "/api/SupplierProduct/" + payload.id,
    payload.dto
  );

  return JSON.parse(result);
}

export async function sendPurchaseOrder(x, id) {
  const result = await data.post("/api/PurchaseOrder/SendOrder/" + id);

  return JSON.parse(result);
}

export async function ChangePurchaseOrderStatus(x, payload) {
  var id = payload.id;
  var toStatus = payload.toStatus;
  const result = await data.post("/api/PurchaseOrder/ChangeOrderStatus/" + id + "?toOrderStatus=" + toStatus); 

  return JSON.parse(result);
}

export async function deletePurchaseOrder(x, id) {
  const result = await data.delete("/api/PurchaseOrder/" + id);

  return result;
}

export async function getPurchaseOrderItemsByProductAndPeriod(x, payload) {
  return await data.get(
    "/api/PurchaseOrderItem/GetByProductAndPeriod/?productId=" +
      payload.productId +
      "&fromDate=" +
      payload.fromDate +
      "&toDate=" +
      payload.toDate
  );
}

export async function getSuggestedOrderItemsBySupplier(x, supplierId) {
  const result = await data.get(
    "/api/PurchaseOrderItem/SuggestedOrderItems/" + supplierId
  );

  return result;
}

export async function getSuggestedOrderItems() {
  const result = await data.get("/api/PurchaseOrderItem/SuggestedOrderItems");

  return result;
}

export async function getConsignor() {
  const result = await data.get("/api/Settings/consignorGet");
  return result;
}

export async function postPurchaseOrderFromOrderItems(x, payload) {
  const result = await data.post(
    "/api/PurchaseOrder/PurchaseOrdersFromOrderItems",
    payload
  );

  return JSON.parse(result);
}

export async function postConsignor(x, payload) {
  const result = await data.post("/api/Settings/consignorAdd", payload);
  return JSON.parse(result);
}

export async function putConsignor(x, payload) {
  const result = await data.put(
    "/api/Settings/consignorUpdate/" + payload.id,
    payload
  );

  return JSON.parse(result);
}

export async function adjustTransactions(x, payload) {
  const result = await data.post(
    "/api/PurchaseOrderItemTransaction/AdjustTransactions",
    payload
  );

  return JSON.parse(result);
}

export async function getCountings() {
  const result = await data.get("/api/Counting");

  return result;
}
export async function getCounting(x, id) {
  const result = await data.get("/api/Counting/" + id);

  return result;
}

export async function postCounting(x, payload) {
  const result = await data.post("/api/Counting", payload);

  return JSON.parse(result);
}

export async function putCounting(x, payload) {
  logger.log(payload);
  const result = await data.put("/api/Counting/" + payload.id, payload);

  return JSON.parse(result);
}

export async function getCountingStocks() {
  const result = await data.get("/api/CountingStock");

  return result;
}

export async function getCountingStocksByCountingId(x, payload) {
  var url =
    "/api/CountingStock/GetByCountingId/" +
    payload.id +
    "?includeEmptyLocations=" +
    payload.includeEmptyLocations;
  const result = await data.get(url);
  return result;
}

export async function getCountingStock(x, id) {
  const result = await data.get("/api/CountingStock/" + id);

  return result;
}

export async function postCountingStocks(x, payload) {
  const id = payload[0].countingId;

  const result = await data.post(
    "/api/CountingStock/UpdateByCountingId/" + id,
    payload
  );

  return JSON.parse(result);
}

export async function postCountingComplete(x, id) {
  const result = await data.post("/api/Counting/Complete/" + id);

  return JSON.parse(result);
}

export async function postCountingCancel(x, id) {
  const result = await data.post("/api/Counting/Cancel/" + id);

  return JSON.parse(result);
}

export async function putWarehouse(x, payload) {
  const result = await data.put("/api/Warehouse/" + payload.id, payload);

  return JSON.parse(result);
}
export async function postWarehouse(x, payload) {
  const result = await data.post("/api/Warehouse", payload);

  return JSON.parse(result);
}

export async function putLocation(x, payload) {
  const result = await data.put("/api/Location/" + payload.id, payload);

  return JSON.parse(result);
}
export async function postLocation(x, payload) {
  const result = await data.post("/api/Location", payload);

  return JSON.parse(result);
}

export async function postBarcode(x, payload) {
  const result = await data.post("/api/Barcode", payload);

  return JSON.parse(result);
}

export async function putBarcode(x, payload) {
  const result = await data.put("/api/Barcode/" + payload.id, payload);

  return JSON.parse(result);
}

export async function deleteBarcode(x, id) {
  const result = await data.delete("/api/Barcode/" + id);

  return result;
}

export async function getBarcodesByProductId(x, id) {
  const result = await data.get("/api/Barcode/GetByProductId/" + id);

  return result;
}

export async function getBarcodes() {
  const result = await data.get("/api/Barcode/");

  return result;
}

export async function postProductDiscount(x, payload) {
  const result = await data.post("/api/ProductDiscount", payload);

  return JSON.parse(result);
}

export async function putProductDiscount(x, payload) {
  const result = await data.put("/api/ProductDiscount/" + payload.id, payload);

  return JSON.parse(result);
}

export async function deleteProductDiscount(x, id) {
  const result = await data.delete("/api/ProductDiscount/" + id);

  return result;
}

export async function getProductDiscount(x, id) {
  const result = await data.get("/api/ProductDiscount/" + id);

  return result;
}

export async function getProductDiscounts() {
  const result = await data.get("/api/ProductDiscount");

  return result;
}

export async function getCustomers() {
  const result = await data.get("/api/Customer");
  return result;
}

export async function getCustomersByStatus(x, statusCode) {
  const result = await data.get(
    "/api/Customer/GetByStatus?statusCode=" + statusCode
  );
  return result;
}

export async function getProductCategory() {
  const result = await data.get("/api/ProductCategory");

  return result;
}
export async function getProductCategoryLinks() {
  const result = await data.get("/api/ProductCategory/ProductCategoryLinks");

  return result;
}

export async function postSupplierDiscount(x, payload) {
  const result = await data.post("/api/SupplierDiscount", payload);

  return JSON.parse(result);
}

export async function putSupplierDiscount(x, payload) {
  const result = await data.put("/api/SupplierDiscount/" + payload.id, payload);

  return JSON.parse(result);
}

export async function deleteSupplierDiscount(x, id) {
  const result = await data.delete("/api/SupplierDiscount/" + id);

  return result;
}

export async function getSupplierDiscount(x, id) {
  const result = await data.get("/api/SupplierDiscount/" + id);

  return result;
}

export async function getSupplierDiscounts() {
  const result = await data.get("/api/SupplierDiscount");

  return result;
}

export async function postProductImportValidate(x, payload) {
  const result = await data.postFormData(
    "/api/Products/ValidateImport",
    payload
  );
  return result;
}

export async function getSyncOrders() {
  const result = await data.get("/api/Sync/SyncOrdersLatest");

  return result;
}

export async function waitEbridgePaymentCompleted(x, orderId) {
  const result = await data.get(
    "/api/CustomerOrder/WaitEbridgePaymentCompleted/" + orderId
  );

  return result;
}

export async function getAvareVersion() {
  const result = await data.get("/api/Settings/ApiVersion");

  return result;
}

export async function getNonCreditedPurchaseOrdersBySupplier(x, payload) {
  const { supplierId, fromDate, toDate } = payload;
  let url = `/api/PurchaseOrder/NonCredited/${supplierId}`;

  if (fromDate || toDate) {
    url += "?";

    if (fromDate) {
      url += `fromDate=${encodeURIComponent(fromDate)}&`;
    }

    logger.log({ fromDate, url });

    if (toDate) {
      url += `toDate=${encodeURIComponent(toDate)}&`;
    }

    url = url.slice(0, -1);
  }

  return await data.get(url);
}

export async function postImport(x, payload) {
  const result = await data.post("/api/Import", payload);
  return result;
}

export function updateLastFileImportTime({ commit }) {
  const time = Date.now();
  commit("setLastFileImportTime", time);
}

export async function getSimplifiedProducts(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending } = payload;

  let url = `/api/products/simplified?pageNumber=${encodeURIComponent(
    pageNumber
  )}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);
  return result;
}


export async function getReferencesPurchaseOrderItem(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending } = payload;

  let url = `/api/PurchaseOrderItem/references?pageNumber=${encodeURIComponent(
    pageNumber
  )}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);
  return result;
}

export async function getReferencesVirtualScrollSuggestedOrderItems(x, payload) {
  const { cursor, pageSize } = payload;
  let url = `/api/PurchaseOrderItem/ReferencesVirtualScroll/SuggestedOrderItems?cursor=${encodeURIComponent(cursor)}&pageSize=${encodeURIComponent(pageSize)}`;
  const result = await data.get(url);
  return result;
}

export async function getReferencesPaginatedSuggestedOrderItems(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending } = payload;

  let url = `/api/PurchaseOrderItem/references/SuggestedOrderItems?pageNumber=${encodeURIComponent(
    pageNumber
  )}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);
  return result;
}

export async function getReferencesProducts(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending } = payload;

  let url = `/api/products/references?pageNumber=${encodeURIComponent(
    pageNumber
  )}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);
  return result;
}


export async function getReferencesCustomerByStatus(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending, statusCode } = payload;

  let url = `/api/Customer/References/status?statusCode=${encodeURIComponent(statusCode)}&pageNumber=${encodeURIComponent(pageNumber)}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);
  return result;
}


export async function getReferencesCustomer(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending } = payload;

  let url = `/api/Customer/References?pageNumber=${encodeURIComponent(pageNumber)}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);
  return result;
}


export async function getReferencesOrders(x, payload) {
  const { pageNumber, pageSize, searchQuery, sortBy, sortDescending, excludeLockedOrders } = payload;

  let url = `/api/CustomerOrder/references?pageNumber=${encodeURIComponent(
    pageNumber
  )}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }
  if(excludeLockedOrders !== undefined) {
    url += `&excludeLockedOrders=${excludeLockedOrders}`
  }

  const result = await data.get(url);
  return result;
}

export async function getProduct(x, productId) {
  const result = await data.get("/api/Products/" + productId);

  return result;
}

export async function getFilteredProducts(payload) {
  const { serialNumber, productId, customerId, pageNumber, pageSize, sortBy, sortDescending, includeDeleted, includeDeactivated } = payload;

  let url = `/api/Widget/GetProductsBySerialNumber?pageNumber=${encodeURIComponent(pageNumber)}&pageSize=${encodeURIComponent(pageSize)}`;

  if (serialNumber) {
    url += `&serialNumber=${encodeURIComponent(serialNumber)}`;
  }
  if (productId) {
    url += `&productId=${encodeURIComponent(productId)}`;
  }
  if (customerId) {
    url += `&customerId=${encodeURIComponent(customerId)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }
  if (includeDeleted !== undefined) {
    url += `&includeDeleted=${includeDeleted}`;
  }
  if (includeDeactivated !== undefined) {
    url += `&includeDeactivated=${includeDeactivated}`;
  }

  const result = await data.get(url);
  return result;
}

export async function getReferencesSupplierProducts(x, payload) {
  const { supplierId, pageNumber, pageSize, searchQuery, sortBy, sortDescending } = payload;

  let url = `/api/products/supplier/${supplierId}/references?pageNumber=${encodeURIComponent(
    pageNumber
  )}&pageSize=${encodeURIComponent(pageSize)}`;

  if (searchQuery) {
    url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
  }

  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }

  if (sortDescending !== undefined) {
    url += `&sortDescending=${sortDescending}`;
  }

  const result = await data.get(url);
  return result;
}